import { render, staticRenderFns } from "./LoginPlatformView.vue?vue&type=template&id=f155faec&"
import script from "./LoginPlatformView.vue?vue&type=script&lang=ts&"
export * from "./LoginPlatformView.vue?vue&type=script&lang=ts&"
import style0 from "./LoginPlatformView.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAlert,VCol,VForm,VRow})
